import _isEqual from 'lodash/isEqual';

export default {
  computed: {
    hasCondition () {
      return this.$props.condition;
    },
    checkCondition () {
      let result = null;
      if (!this.hasCondition) {
        return result;
      }
      let name = this.$props.condition.name;
      const conditionStatus = this.$store.getters['conditions/getCondition'](name);

      // TODO: чтобы не у всех полей менялось значение нужна эта проверка. Надо ее как-то упростить
      if (_isEqual(conditionStatus.name, name)) {
        // console.log(7, 'checkCondition conditionStatus', conditionStatus.resolved);
        result = conditionStatus.resolved;
      }
      return result;
    }
  },
  mounted () {
    this.$nextTick(() => {
      const parent = this.$el.parentNode;
      if (parent && parent.classList.contains('form-row')) {
        if (this.hasCondition && !this.checkCondition) {
          parent.classList.add('is-qs-hidden');
        } else if (parent.classList.contains('is-qs-hidden')) {
          parent.classList.remove('is-qs-hidden');
        }
      }
    })
  },
  watch: {
    checkCondition (val, preVal) {
      if (val !== undefined && val !== preVal) {
        const parent = this.$el.parentNode;
        if (parent && parent.classList.contains('form-row')) {
          if (val) {
            parent.classList.remove('is-qs-hidden');
          } else {
            parent.classList.add('is-qs-hidden');
          }
        }
      }
    }
  }
}
